import React, { useCallback, useMemo } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import style from '../index.module.less';

interface Prop {
  value: string | number;
  label: string | number;
  onClick: (value: string | number) => void;
  deleted: boolean;
  size: 'small' | 'default';
  getTagStyle?: (value: string | number) => React.CSSProperties | undefined;
}

function GroupItem({ value = '', label = '', onClick = () => null, deleted = true, size = 'default', getTagStyle }: Prop) {

  const tagStyle = useMemo(() => {
    if (getTagStyle && typeof getTagStyle === 'function') {
      return getTagStyle(value);
    }
    return undefined;
  }, [getTagStyle, value]);

  const onClickItem = useCallback(
    e => {
      e.stopPropagation();
      e.preventDefault();
      onClick(value);
    },
    [onClick, value]
  );

  const onLiClick = useCallback(e => {
    e.preventDefault();
  }, []);

  return (
    <li
      onClick={onLiClick}
      style={tagStyle}
      className={`${style.cascader_selection__choice} ${!deleted ? style.normal : ''} ${
        size === 'small' ? style.sm : ''
      }`}
    >
      {deleted ? (
        <span onClick={onClickItem} className={style.remove}>
          <CloseOutlined />
        </span>
      ) : null}
      <span className={style.content}>{label}</span>
    </li>
  );
}

export default GroupItem;
